import { render } from "./myjrDetail.vue?vue&type=template&id=3375135a&scoped=true"
import script from "./myjrDetail.vue?vue&type=script&lang=js"
export * from "./myjrDetail.vue?vue&type=script&lang=js"

import "./myjrDetail.vue?vue&type=style&index=0&id=3375135a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3375135a"]])

export default __exports__